import React from "react";
import Icon from "./Icon";

export const ChevronRightCircleFillIcon = () => (
  <Icon>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.5 2C6.98 2 2.5 6.48 2.5 12C2.5 17.52 6.98 22 12.5 22C18.02 22 22.5 17.52 22.5 12C22.5 6.48 18.02 2 12.5 2ZM11.09 9.40973L13.67 12L11.09 14.58C10.7 14.97 10.71 15.61 11.09 16C11.48 16.39 12.11 16.39 12.5 16L15.79 12.71C16.18 12.32 16.18 11.69 15.79 11.3L12.5 7.99973C12.11 7.60973 11.48 7.60973 11.09 7.99973C10.7 8.38973 10.7 9.01973 11.09 9.40973Z" fill="#23410A"/>
  </Icon>
);
